const selects = document.querySelectorAll('.js-select');

if (selects) {
  selects.forEach((select) => {
    select.addEventListener('change', () => {
      select.classList.remove('select--placeholder');
    });
  });
}
